<template>
  <v-chip :color="ativo ? 'green' : 'red'" outlined>
    {{ ativo ? config.labelAtivo : config.labelInativo }}
  </v-chip>
</template>

<script>
export default {
  name: "AtivoLabelComponent",
  props: {
    ativo: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: () => ({
        labelAtivo: "Sim",
        labelInativo: "Não",
      }),
    },
  },
};
</script>
